<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import ReportsHeader from "@/components/reports-header.vue";
import moment from "moment";
export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ReportsHeader,
  },
  watch: {
    report_type() {
      this.generalLedger = [];
    },
  },
  data() {
    return {
      day: moment(new Date(Date.now())).format("YYYY-MM-DD hh:mm:ss a"),

      report_type: true,
      self: this,
      limit: 20,
      page: 1,
      search: null,
      totalBalance: 0,
      totalDebit: 0,
      totalCredit: 0,
      tot: 0,
      counter: 0,
      transactionCounter: 0,
      matchedAccounts: [],
      transactions: [],
      totalDebitBalance: 0,
      totalCreditBalance: 0,
      branch_id: null,
      data: {},

      // genral ledger
      generalLedger: [],
      account: {},
      searchFilter: {},
    };
  },
  computed: {},
  methods: {
    searchAccount(search) {
      this.http
        .post("level-three-chart-of-accounts-copy-1/accounts-setup/search", {
          search,
        })
        .then((res) => {
          if (res.status) {
            this.matchedAccounts = res.data;
          }
        });
    },
    getgeneralLedgerResult() {
      this.http
        .post("transactions/genral-ledger", {
          from: this.searchFilter.from,
          to: this.searchFilter.to,
          account: this.report_type ? this.account.account : null,
        })
        .then((res) => {
          if (res.status) {
            this.totalCredit = 0;
            this.totalDebit = 0;
            this.generalLedger = res.data;

            
              
                            // Load your data file
              
                          let result = [];
                          let total_credit = 0;
                          let total_debit = 0;
                          let opening =0
                          let total_opening=0
                          let isFirstShowIt = true; // Track the first `show_it: 1`
              
                          this.generalLedger.forEach((item,index) => {
                            if (item?.show_it === 1) {
                              // Insert the totals for the previous section if it's not the first `show_it: 1`
                              console.log("step 102["+index,']',item);
                             total_opening += parseFloat(item.opening)
                              if (!isFirstShowIt) {
                                result.push({
                                  opening:opening ,
                                  show_it: 0,
                                  name: "Total",
                                  total_type:true,
                                  created:"2024-10-15T14:59:36.000Z",
                                  total_credit: total_credit,
                                  total_debit: total_debit,
                                  descr: "Total credit and debit for previous entries",
                                });
                               //     if (item.type == "credit") {
                               //   this.totalCredit += parseFloat(item?.value);
                               // } else {
                               //   this.totalDebit += parseFloat(item?.value);
                               // }
                              }
              
                              // Reset totals for the next section and add the current `show_it: 1` item
                              total_credit = 0;
                              total_debit = 0;
                               opening =0;
                              if (item.type === "credit") {
                                total_credit += parseFloat(item.value);
                                this.totalCredit += parseFloat(item?.value);
              
                              } else if (item.type === "debit") {
                                total_debit += parseFloat(item.value);
                                this.totalDebit += parseFloat(item?.value);
              
                              }
                              opening = parseFloat(item.opening)
                              // total_opening += parseFloat(item.opening)
                              result.push(item,);
                              isFirstShowIt = false;
                            } else {
                              // Add the value to either total_credit or total_debit based on the type
                              if (item.type === "credit") {
                                total_credit += parseFloat(item.value);
                                                  this.totalCredit += parseFloat(item?.value);
              
                              } else if (item.type === "debit") {
                                total_debit += parseFloat(item.value);
                                this.totalDebit += parseFloat(item?.value);
              
                              }
                              opening = parseFloat(item.opening)

                              result.push(item);
                            }

                          });
              
                          // After the last section, add the final totals
                          console.log("step 157 :",total_opening);
                          
                          result.push({
                            opening:this.generalLedger[this.generalLedger.length-1].opening,
                            show_it: 0,
                            name: "Total",
                            total_type:true,
                            


                            created:"2024-10-15T14:59:36.000Z",
                            total_credit: parseFloat(total_credit),
                            total_debit: parseFloat(total_debit),
                            descr: "Total credit and debit for previous entries",
                          });
              
                          this.generalLedger = result
                          console.log(this.generalLedger);
              
            // }
          }
        });
    },
    showLabel(one) {
      return this.$i18n.locale == "ar"
        ? one.code + "-" + one.name
        : one.code + "-" + one.name_en; // Display the group label in AutoComplete
    },
    printReport() {
      window.print();
    },
  },
  created() {},
};
</script>

<template>
  <Layout class="no-print">
    <PageHeader
      :dir="$i18n.locale == 'ar' ? 'rtl' : ''"
      :title="$t('general_ledger.general-ledger')"
    />

    <div class="row">
      <div class="col-2">
        <label for=""> {{ $t("general_ledger.specific_account") }}</label>
      </div>
      <div class="col-4">
        <input
          type="radio"
          class="from-control"
          v-model="report_type"
          :value="true"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-2">
        <label for="">{{ $t("general_ledger.all_accounts") }}</label>
      </div>
      <div class="col-4">
        <input
          type="radio"
          class="from-control"
          v-model="report_type"
          :value="false"
        />
      </div>
    </div>

    <div class="row">
      <form @submit.prevent="getgeneralLedgerResult()" class="no-print">
        <div class="row mb-4">
          <!-- {{  report_type }} -->
          <div class="col" v-if="report_type">
            <label class="inline" for="fromJobTitle">{{
              $t("reports.account")
            }}</label>
            <AutoComplete
              :completeOnFocus="true"
              v-model="account.account"
              :suggestions="matchedAccounts"
              @complete="searchAccount($event.query)"
              :optionLabel="showLabel"
              style="color: #333 !important"
            />
          </div>
          <div class="col">
            <label class="inline" for="fromJobTitle">{{
              $t("report.from")
            }}</label>
            <input
              v-model="searchFilter.from"
              type="date"
              class="form-control"
              id="fromJobTitle"
            />
          </div>
          <div class="col">
            <label class="inline" for="toJobTitle">{{ $t("report.to") }}</label>
            <input
              v-model="searchFilter.to"
              type="date"
              class="form-control fromto"
              id="toJobTitle"
            />
          </div>
          <div class="col">
            <br />
            <button type="submit" class="btn btn-primary">
              {{ $t("popups.search") }}
            </button>
          </div>

          <div class="col" v-if="generalLedger.length > 0">
            <br />
            <button
              v-if="report_type"
              class="btn btn-success float-end"
              @click="
                this.$store.dispatch('utils/printElement', {
                  elementId: 'general-ledger-report',
                  orientation: 'l',
                })
              "
            >
              <i class="bx bx-printer"></i>
            </button>
            <button
              v-else
              class="btn btn-success float-end"
              @click="
                this.$store.dispatch('utils/printElement', {
                  elementId: 'general-ledger-report-2',
                  orientation: 'l',
                })
              "
            >
              <i class="bx bx-printer"></i>
            </button>
          </div>
        </div>
      </form>

      <div class="row" v-if="generalLedger.length > 0 && report_type">
        <div id="general-ledger-report" class="card p-3">
          <div class="card-body">
            <ReportsHeader
              :filterdPeriod="`${
                $i18n.locale == 'ar'
                  ? 'من ' + searchFilter?.from + ' الى ' + searchFilter?.to
                  : 'From ' + searchFilter?.from + ' To ' + searchFilter?.to
              }`"
              :reportName="$t('reports.genral')"
              :type="'general'"
              :accountNo="generalLedger[0]?.code"
              :accountName="
                $i18n.locale == 'ar'
                  ? generalLedger[0]?.name
                  : generalLedger[0]?.name_en
              "
              class="mb-4"
            />
            <div class="table-responsive">
              <table
                class="table table-centered table-nowrap table-striped table-hover align-middle"
                :dir="$i18n.locale == 'ar' ? 'rtl' : ''"
              >
                <thead>
                    <tr
                    class="text-light"
                    style="background-color: #2a3042 !important"
                  >
                    <!-- <th scope="col">{{ $t("general_ledger.particular") }}</th> -->
                    <th scope="col">{{ $t("general_ledger.date") }}</th>
                    <th scope="col">{{ $t("general_ledger.tr_id") }}</th>
                    <th scope="col">{{ $t("general_ledger.descr") }}</th>
                    <th scope="col">{{ $t("general_ledger.debit") }}</th>
                    <th scope="col">{{ $t("general_ledger.credit") }}</th>
                    <th scope="col">{{ $t("general_ledger.balance") }}</th>
                  </tr>
                </thead>
                <tbody>
                   <template v-for="transaction in generalLedger" :key="transaction">
                    

                    <template v-if="transaction?.show_it" > <tr >
                    <!-- <td>
                      <span>
                        {{ transaction?.code }}
                      </span>
                    </td> -->
                 
                    <td>{{ transaction?.created.split("T")[0] }}</td>
                    <td></td>
                    <td>
                      {{
                        $i18n.locale == "ar"
                          ? "رصيد إفتتاحي"
                          : 'Opening Balance'
                      }}
                    </td>
                    <td>
                    
                    </td>
                    <td>
                    
                    </td>
                    <td>
                      {{parseFloat(transaction.opening).toLocaleString()  }}
                    </td>

                    <td>
                </td>
                  </tr> </template>
                  <tr v-if="transaction?.name !='Total'" >
                   
                  
                    <td>{{ transaction?.created.split("T")[0] }}</td>
                    <td>#{{ transaction?.id }}</td>
                    <td>
                      {{
                        $i18n.locale == "ar"
                          ? transaction?.descr
                          : transaction?.descr_en
                      }}
                    </td>
                    <td>
                      {{
                        transaction?.type == "debit"
                          ? parseFloat(transaction?.value).toLocaleString()
                          : ""
                      }}
                    </td>
                    <td>
                      {{
                        transaction?.type == "credit"
                          ? parseFloat(transaction?.value).toLocaleString()
                          : ""
                      }}
                    </td>
                    <td></td>
                  </tr>
                  
                  </template>
                  
                  <tr>
                    <!-- <th scope="col" colspan="2"></th> -->
<th scope="col" class="ms-4" :class="this.$i18n.locale =='en'?'text-end':'text-start'" colspan="3">
                      {{$t("general_ledger.account_total")}}
                    </th>
                    <th scope="col" class="total-style">
                      {{ totalDebit.toLocaleString() }}
                    </th>
                    <th scope="col" class="total-style">
                      {{ totalCredit.toLocaleString() }}
                    </th>
                    <th scope="col" class="total-style">
                      {{
                        (
                              parseFloat(totalDebit) - parseFloat(totalCredit)
                            ).toLocaleString()
                      }}
                    </th>
                  </tr>
                </tbody>
              </table>
              <table>
                <thead>
                  <th>{{ $t("reports.report_date") }} :</th>
                  <th>
                    {{ day }}
                  </th>
                </thead>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="generalLedger.length > 0 && !report_type">
        <div id="general-ledger-report-2" class="card p-3">
          <div class="card-body">
            <ReportsHeader
              :filterdPeriod="`${
                $i18n.locale == 'ar'
                  ? 'من ' + searchFilter?.from + ' الى ' + searchFilter?.to
                  : 'From ' + searchFilter?.from + ' To ' + searchFilter?.to
              }`"
              :reportName="$t('reports.genral')"
              :type="'general'"
              :accountNo="'-'"
              :accountName="$i18n.locale == 'ar' ? 'الكل' : 'All'"
              class="mb-4"
            />
            <div class="table-responsive">
              <table
                class="table table-centered table-nowrap table-striped table-hover align-middle"
                :dir="$i18n.locale == 'ar' ? 'rtl' : ''"
              >
                <thead>
                  <tr
                    class="text-light"
                    style="background-color: #2a3042 !important"
                  >
                    <th scope="col">{{ $t("reports.report_name") }}</th>
                    <!-- <th scope="col">{{ $t("general_ledger.particular") }}</th> -->
                    <th scope="col">{{ $t("general_ledger.date") }}</th>
                    <th scope="col">{{ $t("general_ledger.tr_id") }}</th>
                    <th scope="col">{{ $t("general_ledger.descr") }}</th>
                    <th scope="col">{{ $t("general_ledger.debit") }}</th>
                    <th scope="col">{{ $t("general_ledger.credit") }}</th>
                    <th scope="col">{{ $t("general_ledger.balance") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="transaction in generalLedger" :key="transaction">
                    

                    <template v-if="transaction?.show_it" >
                       <tr >
                    <td>
                      <span>
                        {{ transaction?.code }}
                      </span>
                    </td>
                 
                    <td>{{ transaction?.created.split("T")[0] }}</td>
                    <td></td>
                    <td>
                      {{
                        $i18n.locale == "ar"
                          ? "رصيد إفتتاحي"
                          : 'Opening Balance'
                      }}
                    </td>
                    <td>
                    
                    </td>
                    <td>
                    
                    </td>
                    <td>
                      {{parseFloat(transaction.opening).toLocaleString()  }}
                    </td>

                    <td>
                  <!-- {{ transaction.opening}} -->
                </td>
                  </tr> 
                  </template>
                  <tr v-if="transaction?.name !='Total'" >
                   
                    <td>
                      <span v-if="transaction.show_it">
                        {{
                          $i18n.locale == "ar"
                            ? transaction?.name
                            : transaction?.name_en
                        }}
                      </span>
                    </td>
                    <td>{{ transaction?.created.split("T")[0] }}</td>
                    <td>#{{ transaction?.id }}</td>
                    <td>
                      {{
                        $i18n.locale == "ar"
                          ? transaction?.descr
                          : transaction?.descr_en
                      }}
                    </td>
                    <td>
                      {{
                        transaction?.type == "debit"
                          ? parseFloat(transaction?.value).toLocaleString()
                          : ""
                      }}
                    </td>
                    <td>
                      {{
                        transaction?.type == "credit"
                          ? parseFloat(transaction?.value).toLocaleString()
                          : ""
                      }}
                    </td>
                    <td></td>

                    <!-- <td>
                  {{ parseFloat(transaction?.amount).toLocaleString() }}
                </td> -->
                  </tr>
                  <tr v-else>
                    <th scope="col" class="ms-4" :class="this.$i18n.locale =='en'?'text-end':'text-start'" colspan="4">
                      {{$t("general_ledger.account_total")}}
                    </th>

                    <th scope="col" class="total-style">
                      {{ parseFloat(transaction.total_debit).toLocaleString() }}
                    </th>
                    <th scope="col" class="total-style">
                      {{ parseFloat(transaction.total_credit).toLocaleString() }}  
                    </th>
                   
                     <td class="total-style">
                      
                   {{
                    
                    (
                     (parseFloat(transaction.total_debit) +parseFloat(transaction.opening) - parseFloat(transaction.total_credit))
                    ).toLocaleString()
                    }}

                    </td>
                  </tr>  
                  </template>
                  <tr>
                    <th scope="col" colspan="4"></th>

                    <th scope="col" class="total-style">
                      {{ totalDebit.toLocaleString() }}
                    </th>
                    <th scope="col" class="total-style">
                      {{ totalCredit.toLocaleString() }}
                    </th>
                    <th scope="col" class="total-style">
                      {{
                        (
                              parseFloat(totalDebit) - parseFloat(totalCredit)
                            ).toLocaleString()
                      }}
                    </th>
                  </tr>
                </tbody>
              </table>
              <table>
                <thead>
                  <th>{{ $t("reports.report_date") }} :</th>
                  <th>
                    {{ day }}
                  </th>
                </thead>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style scoped>
/*
.table,
td {
  border: 1px solid black;
}
*/
.print {
  display: none;
}

@media print {
  .no-print {
    display: none;
  }

  .print {
    display: block;
  }
}
</style>
